import React from "react";
import "../../tailwind.css";
import { ICommentsDisclaimer } from "../../types/CommentsDisclaimer.types";

const CommentsDisclaimer: React.FC<ICommentsDisclaimer> = (props) => {
  return (
    <div className="mt-[12px] mb-[4px] rounded-[6px] bg-orange-20 p-[8px] max-w-app-column ml-safe-area-l mr-safe-area-r">
      <div className="text-acc-12px font-medium leading-[1.33] tracking-[-0.1px] text-grey-90">
        {props.message
          ? props.message
          : props.isPreceptor
            ? "Please note that this is not a private record. All Preceptors with access to this Preceptee can see the comment history."
            : "This is not a private record. All preceptors you work with will see all your comments, as well as your OO and other managers."}
      </div>
    </div>
  );
};

export default CommentsDisclaimer;
